import React from "react";

const getTooltipIcon = (type, id) => {
  switch (type) {
    case "legacy":
      return (
        <i
          id={id}
          className="pe-7s-help1 text-danger font-weight-bold tooltipIcon"
        />
      );
    case "black":
      return (
        <i
          id={id}
          className="pe-7s-help1 font-weight-bold tooltipIcon"
          style={{ color: "black" }}
        />
      );
    case "star":
      return (
        <i
          id={id}
          className="pe-7s-star font-weight-bold tooltipIcon"
          style={{ color: "#e39924" }}
        />
      );
    case "info":
    default:
      return (
        <i
          id={id}
          className="pe-7s-help1 text-primary font-weight-bold tooltipIcon"
        />
      );
  }
};

export default getTooltipIcon;
